// useIntakeAssets — the published asset manifest, or a single-version preview
// when the URL carries ?assetPreview=<id>.
//
// Starts as the empty manifest and fills in when the fetch resolves, so every
// consumer renders its bundled image first and swaps only if an override
// exists. A failed or dark (404) backend is indistinguishable from "nothing
// published", by design.

import { useEffect, useState } from 'react';
import {
  EMPTY_MANIFEST,
  loadAssets,
  previewIdFromSearch,
} from '@/services/intakeAssets';

export default function useIntakeAssets() {
  const [manifest, setManifest] = useState(EMPTY_MANIFEST);

  useEffect(() => {
    let alive = true;
    const previewId = previewIdFromSearch(
      typeof window === 'undefined' ? '' : window.location.search,
    );
    loadAssets(previewId).then((m) => {
      if (alive) setManifest(m);
    });
    return () => {
      alive = false;
    };
  }, []);

  return manifest;
}
